import { Controller } from "@hotwired/stimulus"
import { fetcher } from "../src/utils/fetcher";

// Connects to data-controller="bookmark-update"
export default class extends Controller {
  static targets = [
    "bookmarkButton",
    "count"
  ];

  connect() {
  }

  // お気に入りの 登録 / 解除 をする
  async toggleBookmark(event) {
    const serviceId = event.params.serviceId;

    if (this.#bookmarked()) {
      await this.#removeBookmark(serviceId);
    } else {
      await this.#addBookmark(serviceId);
    }
  }

  // 気になるを追加する
  async #addBookmark(serviceId) {
    let response;

    try {
      response = await fetcher.post("/api/internal/v1/bookmarks?service_id=" + serviceId);
    } catch(e) {
      return;
    }
    this.bookmarkButtonTargets.map(bookmarkButtonTarget => (bookmarkButtonTarget.classList.add("is_active")));
    this.countTargets.map(countTarget => (++countTarget.textContent));
  }

  // 気になるを解除する
  async #removeBookmark(serviceId) {
    let response;

    try {
      response = await fetcher.delete("/api/internal/v1/bookmarks?service_id=" + serviceId);
    } catch(e) {
      return;
    }
    this.bookmarkButtonTargets.map(bookmarkButtonTarget => (bookmarkButtonTarget.classList.remove("is_active")));
    this.countTargets.map(countTarget => (--countTarget.textContent));
  }

  #bookmarked() {
    return this.bookmarkButtonTarget.classList.contains("is_active");
  }
}
